import { OutcropExamples } from '~/components/wiki/OutcropExamples';
import { useFormationDetailOutletContext } from '~/routes/wiki/regional/lithostrat/formation.$formationId';

export default function FormationAnaloguesRoute() {
  const { formation } = useFormationDetailOutletContext();
  return <OutcropExamples parentType="formation" parent={formation} />;
}
